<template>
  <div class="company-profile-wrapper">
    <!-- company-profile display -->
    <div class="company-profile-container" v-animate-css="'fadeIn'">
      <div class="company-profile-header">
        <label class="title">Public information</label>
        <div class="company-profile-brand">
          <img
            v-if="account.logo"
            :src="$fullUrl('images/profiles/' + account.logo)"
          />
          <img v-else src="@/assets/icons/logo_avatar.svg" alt />
          <span>{{ account.name | validate }}</span>
          <div class="location-data">
            <span>{{ account.location | validate }}</span>
          </div>

          <p
            class="company-desc"
            v-if="account.description"
            v-html="account.description"
          ></p>
          <div class="company-profile-option">
            <button class="edit-btn" @click="updateAccount(account)">
              Edit Account Profile
            </button>
          </div>
        </div>
        <div class="company-profile-options"></div>
      </div>
      <div class="company-profile-body" style="margin-bottom: 20px">
        <ul
          class="contact-items"
          v-if="account.contacts && account.contacts.length > 0"
        >
          <li class="contact-starter">
            <div class="contact-item-header">
              <label>Contacts</label>
            </div>
          </li>
          <li
            class="contact-item"
            v-for="(item, index) in account.contacts"
            :key="index"
          >
            <panel-expand :expand="false">
              <template v-slot:header>
                <div class="contact-item-header">
                  <div class="contact-item-brand">
                    <img src="@/assets/contact-avatar.svg" />
                  </div>
                  <div class="content">
                    <div class="title">
                      <label
                        >{{ item.first_name | validate }}
                        {{ item.last_name | validate }}</label
                      >
                    </div>
                    <span>{{ item.title | validate }}</span>
                    <span>{{ item.email | validate }}</span>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
        <div class="empty-widget" v-else>
          <div class="empty-widgetheader">
            <label>Contacts</label>
          </div>
          <div class="empty-widget-body">
            <p>
              You have not yet added any contact
              <br />Click below to add one
            </p>
            <button class="add-btn" @click="selectTab('contacts')">
              Add a Contact
            </button>
          </div>
        </div>
      </div>
      <div class="company-profile-body">
        <ul class="project-items" v-if="projects.length > 0">
          <li class="project-starter">
            <div class="project-item-header">
              <label>Project</label>
            </div>
          </li>
          <li
            class="project-item"
            v-for="(item, i) in projects.slice(0, 5)"
            :key="i"
          >
            <panel-expand :expand="false">
              <template v-slot:header>
                <div class="project-item-header">
                  <div class="project-item-brand">
                    <img src="@/assets/icons/projects_icon.svg" alt />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{ item.name | validate }}</label>
                      <span v-if="item.address">{{
                        item.address | validate
                      }}</span>

                      <span class="date">
                        <span v-if="item.from">{{
                          item.from | formatDate | validate
                        }}</span>
                        <span class="separator" v-if="item.from && item.to"
                          >-</span
                        >
                        <span v-if="item.to">{{
                          item.to | formatDate | validate
                        }}</span>
                      </span>
                    </div>
                    <div class="options">
                      <div class="btns">
                        <span v-if="item.verified" class="verified-status"
                          >Verified</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
        <div class="empty-widget" v-else>
          <div class="empty-widgetheader">
            <label>Projects</label>
          </div>
          <div class="empty-widget-body">
            <p>
              You have not yet added any project
              <br />Click below to add one
            </p>
            <button class="add-btn" @click="selectTab('projects')">
              Add a Project
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->

    <!-- Lead and Task widget -->
    <div class="lead-task-section">
      <div
        class="widget-container"
        v-if="account.tasks && account.tasks.length > 0"
      >
        <div class="container-header">
          <h3>Tasks</h3>
          <button class="btn-view-all" @click="$router.push({ name: 'task' })">
            View All
          </button>
        </div>
        <div class="widget-body">
          <div
            v-for="(task, i) in account.tasks.slice(0, 5)"
            :key="i"
            class="card"
          >
            <div class="card-header">
              <div class="title">
                {{ task.name | validate }}
              </div>
              <div class="card-type">
                <label :style="{ color: getColor(task.type) }">{{
                  task.type | validate
                }}</label>
                <div
                  :style="{ 'background-color': getColor(task.type) }"
                  class="type-box"
                ></div>
              </div>
            </div>
            <div class="compang-widget">
              <span class="company-name">{{ account.name | validate }}</span>
              <div class="company-contact" v-if="task.contacts.length > 0">
                <template v-for="(contact, index) in task.contacts">
                  <span :key="index" v-if="index == 0">
                    {{ contact.first_name | validate }}
                    {{ contact.last_name | validate }}
                  </span>
                </template>
                <div v-if="task.contacts.length > 1" class="other-contact">
                  , & {{ (task.contacts.length - 1) | validate }} more contacts
                </div>
              </div>
            </div>
            <div class="members">
              <div
                class="member"
                v-for="(member, index) in task.assignees"
                :key="index"
              >
                <assingProfileToolTip :member="member">
                  <img
                    v-if="member.profile_picture"
                    :src="$fullUrl('images/profiles/' + member.profile_picture)"
                    :class="{ override: index > 0 }"
                  />
                  <img
                    v-else
                    :class="{ override: index > 0 }"
                    src="@/assets/avatar.png"
                  />
                </assingProfileToolTip>
                <span v-if="task.assignees.length == 1" class="name">{{
                  (member.first_name + " " + member.last_name) | validate
                }}</span>
              </div>
            </div>
            <div class="due-date" v-if="task.due_date">
              {{ moment(task.due_date).format("ddd, DD MMM YYYY") | validate }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="widget-container"
        v-if="account.leads && account.leads.length > 0"
      >
        <div class="container-header">
          <h3>Leads</h3>
          <button class="btn-view-all" @click="$router.push({ name: 'leads' })">
            View All
          </button>
        </div>
        <div class="widget-body">
          <div
            v-for="(lead, i) in account.leads.slice(0, 5)"
            :key="i"
            class="lead-card"
          >
            <div class="card-header"></div>
            <div class="title-widget">
              <span class="lead-name">{{ lead.name | validate }}</span>
            </div>
            <div class="compang-widget">
              <span class="company-name">
                {{ account.name | validate }}
              </span>

              <div
                class="company-contact"
                v-if="lead.contacts && lead.contacts.length > 0"
              >
                <template v-for="(contact, index) in lead.contacts">
                  <span :key="index" v-if="index == 0">
                    {{ contact.first_name | validate }}
                    {{ contact.last_name | validate }}
                  </span>
                </template>
                <div v-if="lead.contacts.length > 1" class="other-contact">
                  , & {{ (lead.contacts.length - 1) | validate }} more contacts
                </div>
              </div>
            </div>

            <div class="members">
              <div
                class="member"
                v-for="(member, index) in lead.assignees"
                :key="index"
              >
                <assingProfileToolTip :member="member">
                  <img
                    v-if="member.profile_picture"
                    :src="$fullUrl('images/profiles/' + member.profile_picture)"
                    :class="{ override: index > 0 }"
                  />
                  <img
                    v-else
                    :class="{ override: index > 0 }"
                    src="@/assets/avatar.png"
                  />
                </assingProfileToolTip>
                <span v-if="lead.assignees.length == 1" class="name">{{
                  (member.first_name + " " + member.last_name) | validate
                }}</span>
              </div>
            </div>
            <div class="price">{{ lead.value | validate }} USD</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add - Update Modal -->
    <div class="overlay" v-if="show_form_add_update">
      <div class="form-widget-modal">
        <div class="moder-header">
          <h4 v-if="!account_form.id">Add New Accounts</h4>
          <h4 v-else>Update Accounts</h4>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label>Account Name (*)</label>
            <input type="text" v-model="account_form.name" class="input-form" />
          </div>

          <div class="input-group">
            <label>Description</label>
            <textarea
              type="text"
              v-model="account_form.description"
              class="input-form"
            ></textarea>
          </div>
          <div class="twin-input">
            <div class="input-group">
              <label>Phone</label>
              <input
                type="text"
                v-model="account_form.phone"
                class="input-form"
              />
            </div>
            <div class="input-group">
              <label>Email</label>
              <input
                type="text"
                v-model="account_form.email"
                class="input-form"
              />
            </div>
          </div>
          <div class="twin-input">
            <div class="input-group">
              <label>Location</label>
              <map-helper v-model="account_form.location"></map-helper>
            </div>
            <div class="input-group">
              <label>Corporate identity</label>
              <input
                type="text"
                v-model="account_form.corporate_identity"
                class="input-form"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <c-button
            :loading="adding_acc_loading"
            @click="submitAccountData"
            class="btn-save"
            >Save</c-button
          >
          <button class="btn-cancel" @click="show_form_add_update = false">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";

export default {
  name: "genelar-info-profile",
  components: {
    panelExpand,
  },
  props: {},
  data: () => {
    return {
      account: {},
      projects: [],
      show_form_add_update: false,
      account_form: {
        id: null,
        account_id: null,
        name: "",
        description: "",
        responsible: "",
        phone: "",
        email: "",
        location: "",
        tags: [],
        corporate_identity: "",
        vat_number: "",
      },
      adding_acc_loading: false,
      task_types: [
        {
          name: "Task",
          color: "#0884AF",
        },
        {
          name: "Follow up",
          color: "#1BA5A4",
        },
        {
          name: "Call",
          color: "#FFC273",
        },
        {
          name: "Mail",
          color: "#9FD076",
        },
        {
          name: "Meeting",
          color: "#ACAF5C",
        },
        {
          name: "Other",
          color: "#ED6400",
        },
      ],
    };
  },
  mounted() {
    let vm = this;
    vm.getStartData();
    vm.getProjectsData();
  },
  computed: {},
  methods: {
    getColor(val) {
      let vm = this;
      let color = "";
      vm.task_types.forEach((item) => {
        if (item.name == val) {
          color = item.color;
        }
      });
      return color;
    },
    updateAccount(item) {
      let vm = this;
      vm.account_form.id = item.id;
      vm.account_form.account_id = item.id;
      vm.account_form.name = item.name;
      vm.account_form.description = item.description;
      vm.account_form.responsible = item.responsible;
      vm.account_form.tags = item.tags;
      vm.account_form.corporate_identity = item.corporate_identity;
      vm.account_form.vat_number = item.vat_number;
      vm.account_form.phone = item.phone;
      vm.account_form.email = item.email;
      vm.account_form.location = item.location;
      vm.show_form_add_update = true;
    },
    submitAccountData() {
      let vm = this;
      const rules = {
        name: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Account name can not be empty";
          },
        },
        phone: {
          run: (value) => {
            if (value.length == 0) {
              return "Phone number can not be empty";
            } else {
              if (/^\d+$/.test(value)) {
                return false;
              } else {
                return "We don't accept any character on phone number, use only number";
              }
            }
          },
        },
        email: {
          run: (value) => {
            if (value.length == 0) {
              return "Email can not be empty";
            } else {
              const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (re.test(String(value).toLowerCase())) {
                return false;
              }
            }
            return "Email is invalid";
          },
        },
        location: {
          run: (value) => {
            if (value) {
              return false;
            }
            return "Select account location";
          },
        },
        corporate_identity: {
          run: (value) => {
            if (value.length == 0) {
              return "Select location";
            } else {
              if (/^\d+$/.test(value)) {
                return false;
              } else {
                return "Use only number on corporate identity";
              }
            }
          },
        },
      };
      if (vm.$isFieldsValidated(vm.account_form, rules)) {
        vm.adding_acc_loading = true;
        if (vm.account_form.id) {
          vm.$store
            .dispatch("ACCOUNT_UPDATE", vm.account_form)
            .then((response) => {
              vm.adding_acc_loading = false;
              vm.show_form_add_update = false;
              vm.getStartData();
              vm.$emit("updateParent", null);
            })
            .catch((error) => {
              console.error({ error });
              vm.adding_acc_loading = false;
            });
        }
      }
    },
    selectTab(type) {
      let vm = this;
      vm.$router
        .push({
          name: "account-view",
          params: { type: type, id: vm.$route.params.id },
        })
        .catch((error) => {});
    },
    getProjectsData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_PROJECT_GET_ALL", {
          account_id: parseInt(vm.$route.params.id),
        })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.projects = vm.processSkills(responce.data);
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    getStartData() {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.account = responce.data;
        })
        .catch((error) => {});
    },
    processSkills(obj) {
      return obj.map((item) => {
        let skills = {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        };
        let skills_data = [];
        if (item.skills && item.skills.length > 0) {
          item.skills.forEach((skill) => {
            skill.tools.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.tools.push(obj);
            });
            skill.domains.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.domains.push(obj);
            });
            skill.competences.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.competences.push(obj);
            });
            skill.roles.forEach((item) => {
              let obj = {
                name: item.name,
                priority: item.priority,
                level: parseInt(item.priority),
              };
              skills.roles.push(obj);
            });
            skill.languages.forEach((item) => {
              if (item.lang) {
                let obj = {
                  lang: { name: item.lang.name },
                  level: parseInt(item.level),
                };
                skills.languages.push(obj);
              }
            });
          });
        }
        eventBus.$set(item, "skills_data", item.skills);
        eventBus.$set(item, "skills", skills);

        return item;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.company-profile-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 70% 30%;
  grid-column-gap: 10px;
  padding-right: 10px;
  @media (min-width: 300px) and (max-width: 630px) {
    grid-template-columns: 100%;
    padding-right: 0px;
    overflow-y: auto;
  }
  .company-profile-container {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 70px;
    @media (min-width: 300px) and (max-width: 630px) {
      height: unset;
      overflow-y: unset;
      padding-bottom: 10px;
    }
    .company-profile-header {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      margin-bottom: 10px;
      .title {
        font-size: 16px !important;
        margin-bottom: 16px;
        display: none;
        @media (min-width: 300px) and (max-width: 630px) {
          display: block;
        }
      }
      .company-profile-brand {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @media (min-width: 300px) and (max-width: 630px) {
          border-radius: 4px;
          border: 1px solid #ddd;
          padding: 15px;
        }
        .location-data,
        .contact-data {
          .separator {
            margin: 0px 20px;
          }
        }
        img {
          width: 60px;
          height: 60px;
          object-fit: contain;
          margin-bottom: 10px;
          border-radius: 50%;
        }
        span {
          font-family: "AvenirBook";
          font-size: 14px;
          margin-bottom: 10px;
        }
        p.company-desc {
          font-size: 14px;
          line-height: 20px;
          font-family: "AvenirBook";
          margin: 10px 50px 10px 50px;
          @media (min-width: 300px) and (max-width: 630px) {
            margin: 10px 10px 10px 10px;
            text-align: left;
          }
        }
        .company-profile-option {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          .go-to-read-btn {
            background: #1885ad 0% 0% no-repeat padding-box;
            border-radius: 5px;
            padding: 10px 18px;
            font-size: 14px;
            margin-top: 13px;
            color: #fff;
            cursor: pointer;
            outline: none;
            width: 180px;
            margin-right: 20px;
            font-family: "AvenirBook";
            text-decoration: none;
            text-align: center;
          }
          .edit-btn {
            background: #ffffff 0% 0% no-repeat padding-box;
            border: 1px solid #ddd;
            border-radius: 5px;
            padding: 10px 18px;
            font-size: 14px;
            margin-top: 13px;
            color: #646262;
            cursor: pointer;
            outline: none;
            width: 180px;
            font-family: "AvenirBook";
            border: 1px solid #ccc;
          }
        }
      }
      .company-profile-options {
        .btn-edit-info {
          box-shadow: 0px 1px 3px #00000029;
          border: 1px solid #36adae;
          border-radius: 5px;
          color: #1885ad;
          padding: 10px 50px;
          font-family: "AvenirBook";
        }
      }
    }
    .company-profile-body {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      ul.contact-items {
        padding-left: 0px;
        list-style: none;
        .contact-starter {
          margin-bottom: 6px;
          .contact-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0px;
            label {
              color: #000000;
              font-family: "AvenirBook";
              font-size: 16px;
            }
            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;
              font-family: "AvenirBook";
              font-style: italic;
              background: transparent;
            }
          }
          p {
            color: #131313;
            font-family: "AvenirBook";
          }
        }
        .contact-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          .contact-item-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 17px 17px;
            .contact-item-brand {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              img {
                width: 60px;
                height: 60px;
                object-fit: cover;
                margin-right: 15px;
                border-radius: 50%;
              }
            }
            .content {
              display: flex;
              flex-direction: column;
              width: 100%;
              .title {
                display: flex;
                justify-content: space-between;
                width: 100%;
                font-family: "AvenirBook";
                label {
                  display: block;
                  font-size: 14px;
                  font-family: "AvenirBlack";
                  margin-bottom: 7px;
                  font-weight: 800;
                }
              }
              span {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                margin-bottom: 6px;
              }
            }
            .toogle-panel-btn {
              padding: 1px 40px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
            }
          }
          .contact-item-body {
            padding: 10px;
            h4 {
              font-family: "AvenirBook";
            }
            img {
              width: 100%;
            }
            p {
              font-size: 14px;
              font-family: "AvenirBook";
            }
            label {
              color: #808080;
              font-size: 15px;
              display: block;
              margin-bottom: 8px;
              font-family: "AvenirBook";
            }
            .skills-widget {
              display: flex;
              flex-wrap: wrap;
              .skill-item {
                background: #707070 0% 0% no-repeat padding-box;
                border-radius: 25px;
                color: #ffffff;
                font-size: 13px;
                font-family: "AvenirBook";
                padding: 5px 22px;
                margin-right: 10px;
                margin-bottom: 10px;
              }
            }
            .contact-info {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              .col-one,
              .col-two {
                width: 50%;
                label {
                  color: #808080;
                  margin-bottom: 3px;
                  margin-top: 20px;
                }
                p {
                  color: #000;
                  margin: 0px;
                }
              }
            }
          }
        }
      }
      .empty-widget {
        .empty-widget-body {
          height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          h1 {
            margin-bottom: 30px;
          }
          p {
            text-align: center;
            width: 270px;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
    .company-profile-body {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      ul.project-items {
        padding-left: 0px;
        list-style: none;
        .project-starter {
          margin-bottom: 6px;
          .project-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0px;
            label {
              color: #000000;
              font-family: "AvenirBook";
              font-size: 16px;
            }
            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;
              font-family: "AvenirBook";
              font-style: italic;
              background: transparent;
            }
          }
          p {
            color: #131313;
            font-family: "AvenirBook";
          }
        }
        .project-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          .project-item-header {
            display: grid;
            padding: 17px 17px;
            grid-template-columns: 90px calc(98% - 90px);
            grid-column-gap: 20px;
            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 100%;
              padding: 10px 12px;
            }
            .project-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90px;
              height: 90px;
              background: rgb(228, 228, 228);
              border-radius: 50%;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 60px;
                height: 60px;
                display: none;
              }
              img {
                width: 70px;
                height: 70px;
                object-fit: contain;
                @media (min-width: 300px) and (max-width: 630px) {
                  width: 33px;
                  height: 33px;
                }
              }
            }
            .content {
              display: flex;
              justify-content: space-between;

              .title-row {
                font-family: "AvenirBook";
                padding-right: 9px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                label {
                  display: block;
                  font-size: 14px;
                  font-family: "AvenirBlack";
                  margin-bottom: 1px;
                  font-weight: 800;
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 12px;
                  }
                }

                span {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  margin-bottom: 6px;
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 12px;
                  }
                }
                .date {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  .separator {
                    margin: 0px 5px;
                  }
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 11px;
                  }
                }
              }
              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;
                .btns {
                  display: flex;
                  margin-top: -5px;
                  .verified-status {
                    color: #0590ab;
                    margin: 10px 0px;
                  }
                  .btn-verify {
                    height: 40px;
                    width: 100px;
                    outline: none;
                    color: #fff;
                    background-color: #1890a9;
                    border-radius: 5px;
                  }
                }

                .status {
                  color: #000;
                  font-family: "AvenirBook";
                  font-size: 13px;
                }

                .toogle-panel-btn {
                  width: 19px;
                  padding: 0;
                  height: 22px;
                  font-size: 20px;
                  position: absolute;
                  bottom: 5px;
                  right: 7px;
                }
              }
            }
            .toogle-panel-btn {
              padding: 1px 40px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
            }
          }
          .project-item-body {
            padding: 10px;
            h4 {
              font-family: "AvenirBook";
            }
            img {
              width: 100%;
            }
            p {
              font-size: 14px;
              font-family: "AvenirBook";
            }
            label {
              color: #808080;
              font-size: 15px;
              display: block;
              margin-bottom: 8px;
              font-family: "AvenirBook";
            }
            .skills-widget {
              display: flex;
              flex-wrap: wrap;
              .skill-item {
                background: #707070 0% 0% no-repeat padding-box;
                border-radius: 25px;
                color: #ffffff;
                font-size: 13px;
                font-family: "AvenirBook";
                padding: 5px 22px;
                margin-right: 10px;
                margin-bottom: 10px;
              }
            }
            .project-info {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              .col-one,
              .col-two {
                width: 50%;
                label {
                  color: #808080;
                  margin-bottom: 3px;
                  margin-top: 20px;
                }
                p {
                  color: #000;
                  margin: 0px;
                }
              }
            }
          }
        }
      }
      .empty-widget {
        .empty-widget-body {
          height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 0px 200px;
          p {
            text-align: center;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
  }
  .lead-task-section {
    border-radius: 5px;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 70px;
    @media (min-width: 300px) and (max-width: 630px) {
      height: unset;
      overflow-y: unset;
      padding: 0px 20px;
      background: #fff;
      padding-bottom: 170px;
    }
    .widget-container {
      background: #ffffff;
      padding: 10px 10px;
      margin-bottom: 20px;
      border-radius: 5px;
      .container-header {
        display: flex;
        justify-content: space-between;
        padding: 15px 0px;
        h3 {
          font-size: 17px;
          margin: 0px;
        }
        .btn-view-all {
          color: #0884af;
        }
      }
      .widget-body {
        .card {
          width: 100%;
          background: #f5f5f5;
          position: relative;
          padding: 8px 8px;
          border-radius: 5px;
          margin-bottom: 5px;
          min-height: 72px;
          .card-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            width: 100%;
            .title {
              font-size: 14px;
              font-family: "AvenirRoman";
              font-weight: 800;
              color: #000;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 115px;
            }

            .card-type {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              label {
                font-size: 10px;
                white-space: nowrap;
                text-align: right;
              }
              .type-box {
                height: 15px;
                width: 15px;
                border-radius: 2px;
                margin-left: 5px;
              }
            }
          }
          .compang-widget {
            display: flex;
            flex-direction: column;
            padding-right: 20px;
            .company-name {
              color: #707070;
              font-size: 12px;
              margin-bottom: 5px;
            }
            .company-contact {
              display: flex;
              align-items: center;
              margin-bottom: 5px;
              span {
                font-size: 12px;
                white-space: nowrap;
              }
              .other-contact {
                color: #ccc;
                font-size: 12px;
                white-space: nowrap;
              }
            }
          }
          .members {
            display: flex;
            .member {
              display: flex;
              align-items: center;
              img {
                width: 20px;
                height: 20px;
                object-fit: cover;
                margin-right: 4px;
                border-radius: 50%;
                border: 2px solid #fff;
                &.override {
                  margin-left: -10px;
                }
              }
              .name {
                background: #06a1a11f;
                padding: 2px 5px;
                border-radius: 15px;
                font-size: 11px;
                color: #04a5a5;
                display: block;
              }
            }
          }
          .due-date {
            position: absolute;
            bottom: 10px;
            right: 15px;
            font-size: 10px;
          }

          &.hold {
            border: solid#04a5a5 1px;
            border-radius: 5px;
          }
          &.invisible {
            opacity: 0.5;
          }
        }
        .lead-card {
          width: 100%;
          background: #f5f5f5;
          position: relative;
          padding: 15px 15px;
          cursor: pointer;
          border-radius: 5px;
          margin-bottom: 5px;
          &:hover {
            .card-header {
              .card-checkbox {
                display: block;
              }
            }
          }
          .card-header {
            display: flex;
            justify-content: flex-end;
            position: absolute;
            right: 2px;
            top: 8px;
            .card-checkbox:checked {
              display: block;
            }
            .card-checkbox {
              display: none;
            }
          }
          .title-widget {
            margin-bottom: 5px;
            .lead-name {
              font-size: 14px;
              font-family: "AvenirRoman";
              font-weight: 800;
              color: #000;
              overflow: hidden;
              text-decoration: none;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 115px;
            }
          }
          .compang-widget {
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
            .company-name {
              color: #0884af;
              font-size: 12px;
            }

            .company-contact {
              display: flex;
              align-items: center;
              margin-bottom: 5px;
              span {
                font-size: 12px;
                white-space: nowrap;
              }
              .other-contact {
                color: #ccc;
                font-size: 12px;
                white-space: nowrap;
              }
            }
          }

          .members {
            margin-top: 5px;
            display: flex;
            .member {
              display: flex;
              align-items: center;
              img {
                width: 20px;
                height: 20px;
                object-fit: cover;
                margin-right: 4px;
                border-radius: 50%;
                border: 2px solid #fff;
                &.override {
                  margin-left: -10px;
                }
              }
              .name {
                background: #06a1a11f;
                padding: 2px 5px;
                border-radius: 15px;
                font-size: 11px;
                color: #04a5a5;
                display: block;
              }
            }
          }
          .price {
            color: rgb(134, 134, 134);
            position: absolute;
            bottom: 18px;
            right: 15px;
            font-size: 10px;
          }
          .attachment {
            width: 100%;
            padding: 0px 10px;
            img {
              width: 100%;
              height: 70px;
              object-fit: cover;
              border-radius: 20px;
            }
          }
        }
      }
    }
  }
  .form-widget-modal {
    width: 400px;
  }
}

.input-flex {
  display: flex;
}
</style>